import React from 'react';
import {
  DefaultNotification,
  IDefaultNotificationProps,
} from '../../DefaultNotification';
import { InvoiceNames, statusMessages } from './helpers';

export interface IExpiredInvoiceNotificationProps extends IDefaultNotificationProps {
  status: InvoiceNames;
}

function ExpiredInvoicesNotification({
  status,
  ...rest
}: IExpiredInvoiceNotificationProps) {
  return (
    <DefaultNotification {...rest}>
      <small className="mt-2 font-semibold text-[rgba(59,58,52,0.9)]">
        <u>Status:</u> <b className="font-bold">{statusMessages[status]}</b>
      </small>
    </DefaultNotification>
  );
}

export default ExpiredInvoicesNotification;
